import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';
import { lastValueFrom } from 'rxjs';

export interface InstrumentOption {
  id: number;
  name: string;
}

export class Instrument extends Resource {
  public override attributes = {
    name: '',
    slug: '',
  };

  public override relationships = {};
}

@Injectable({
  providedIn: 'root',
})
export class InstrumentService extends Service<Instrument> {
  public override resource = Instrument;
  public override type = 'Instrument';
  public override path = '/api/instruments';

  public async fetchInstrumentOptions(): Promise<InstrumentOption[]> {
    const options: InstrumentOption[] = [];
    const seenIds = new Set<number>();
    for (let pageNumber = 1; ; pageNumber++) {
      const page = await lastValueFrom(this.all({ page: { number: pageNumber, size: 100 } }));
      let added = 0;
      for (const instrument of page.data) {
        const id = Number(instrument.id);
        if (seenIds.has(id)) continue;
        seenIds.add(id);
        options.push({ id, name: instrument.attributes.name });
        added++;
      }
      const total = page.page.total_resources;
      if (!added || (total > 0 && options.length >= total)) break;
    }
    return options;
  }
}
